
import React from 'react';
import './customBanner.css';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';

function CustomBanner({sideText, sideText2, slideUrl}) {

    return (
        <section id="cta-697">
            <Carousel>
                 <Carousel.Item>
                    <a href="/donate">
                        <img 
                            className="d-block mx-auto carousel-img"
                            src="/images/GovardhanPuja2025.png"
                            srcSet="/images/GovardhanPuja2025.png 1x, /images/GovardhanPuja2025.png 2x"
                            alt="GovardhanPuja2025" >
                        </img>
                    </a>
                </Carousel.Item>
                <Carousel.Item>
                    <a href="/donate">
                        <img 
                            className="d-block mx-auto carousel-img"
                            src="/images/1.png"
                            srcSet="/images/1.png 1x, /images/1.png 2x"
                            alt="Donate to Temple" >
                        </img>
                    </a>
                </Carousel.Item>
                <Carousel.Item>
                    <a href="/donate">
                        <img 
                            className="d-block mx-auto carousel-img"
                            src="/images/2.png"
                            srcSet="/images/2.png 1x, /images/2.png 2x"
                            alt="Donate to Temple" >
                        </img>
                    </a>
                </Carousel.Item>
                <Carousel.Item>
                    <a href="/donate">
                        <img 
                            className="d-block mx-auto carousel-img"
                            src="/images/3.png"
                            srcSet="/images/3.png 1x, /images/3.png 2x"
                            alt="Donate to Temple" >
                        </img>
                    </a>
                </Carousel.Item>
            </Carousel>
        </section>
    )
}
export default CustomBanner